import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

function Sidebar() {
  const [openCadastroBasico, setOpenCadastroBasico] = useState(false);

  const [openCCIR, setOpenCCIR] = useState(false);
  const [openDITR, setOpenDITR] = useState(false);
  const [openIPTU, setOpenIPTU] = useState(false);

  const [openRelogioEnergia, setOpenRelogioEnergia] = useState(false);
  const [openRelogioAgua, setOpenRelogioAgua] = useState(false);
  const [openPessoas, setOpenPessoas] = useState(false);

  const [openCadastrosAuxiliares, setOpenCadastrosAuxiliares] = useState(false);

  const [openAreasConstruidas, setOpenAreasConstruidas] = useState(false);

  const [openCadastroTiposAreas, setOpenCadastroTiposAreas] = useState(false);

  const [openLancamentosAreas, setOpenLancamentosAreas] = useState(false);

  const [openUnidadesLocaveis, setOpenUnidadesLocaveis] = useState(false);

  const [openWorkflowContratoLocacao, setOpenWorkflowContratoLocacao] = useState(false);

  const [openWorkflowOutrosInterno, setOpenWorkflowOutrosInterno] = useState(false);

  const [openWorkflowOutrosExterno, setOpenWorkflowOutrosExterno] = useState(false);

  const [openTemplatesContrato, setOpenTemplatesContrato] = useState(false);

  const [openAdministracao, setOpenAdministracao] = useState(false);

  const [openAlteracoesContratuais, setOpenAlteracoesContratuais] = useState(false);

  const [openSistema, setOpenSistema] = useState(false);
  const [buscaMenu, setBuscaMenu] = useState("");

  const navigate = useNavigate();

  const baseItemClasses = "block px-4 py-2 rounded-md transition-colors text-gray-200 hover:bg-[#2a2d36]";
  const activeItemClasses = "bg-[#e30613] text-white font-semibold";

  const subItemClasses = "block px-4 py-2 rounded-md transition-colors text-gray-200 hover:bg-[#2a2d36] text-sm";

  const groupBtnClasses = "w-full px-4 py-2 rounded-md transition-colors text-gray-200 hover:bg-[#2a2d36] text-left";

  const itensAreasConstruidas = [
    {
      nome: "TIPO ÁREA",
      slug: "tipo-area",
    },
    {
      nome: "ÁREA TERRENOS URBANIZADOS E NÃO URBANIZADOS",
      slug: "area-terrenos-urbanizados-nao-urbanizados",
    },
    {
      nome: "TIPO ÁREA URBANIZADA",
      slug: "tipo-area-urbanizada",
    },
    {
      nome: "SETORES E SUBSETORES",
      slug: "setores-subsetores",
    },
    {
      nome: "TIPO ÁREA CONSTRUÍDA",
      slug: "tipo-area-construida",
    },
    {
      nome: "VAGAS ESTACIONAMENTO",
      slug: "vagas-estacionamento",
    },
    {
      nome: "DOCAS",
      slug: "docas",
    },
    {
      nome: "PALLET",
      slug: "pallet",
    },
    {
      nome: "SISTEMAS CONSTRUTIVOS",
      slug: "sistemas-construtivos",
    },
    {
      nome: "INSTALAÇÕES E EQUIPAMENTOS",
      slug: "instalacoes-equipamentos",
    },
  ];
  const itensWorkflowContratoLocacao = [
    {
      nome: "PROPOSTA COMERCIAL",
      rota: "/proposta-comercial",
    },
    {
      nome: "FICHA DE CADASTRO",
      rota: "/ficha-cadastro",
    },
    {
      nome: "CONTRATO LOCAÇÃO",
      rota: "/contratos",
    },
    {
      nome: "VISTORIA INICIAL",
      rota: "/workflow-contrato-locacao/vistoria-inicial",
    },
    {
      nome: "ENTREGA CHAVE",
      rota: "/workflow-contrato-locacao/entrega-chave",
    },
    {
      nome: "ADITIVOS",
      rota: "/workflow-contrato-locacao/aditivos",
    },
    {
      nome: "VISTORIAS INTERMED.",
      rota: "/workflow-contrato-locacao/vistorias-intermed",
    },
    {
      nome: "CONFISSÕES DE DÍVIDA",
      rota: "/workflow-contrato-locacao/confissoes-divida",
    },
    {
      nome: "AVISO PRÉVIO",
      rota: "/workflow-contrato-locacao/aviso-previo",
    },
    {
      nome: "VISTORIA FINAL",
      rota: "/workflow-contrato-locacao/vistoria-final",
    },
    {
      nome: "DISTRATO",
      rota: "/workflow-contrato-locacao/distrato",
    },
  ];

  const itensWorkflowOutrosInterno = [
    {
      nome: "INFORMAÇÕES EDITÁVEIS",
      rota: "/workflow-outros-contratos-interno/informacoes-editaveis",
    },
    {
      nome: "CONTRATO",
      rota: "/workflow-outros-contratos-interno/contrato",
    },
  ];

  const itensWorkflowOutrosExterno = [
    {
      nome: "CONTRATO",
      rota: "/workflow-outros-contratos-externo/contrato",
    },
  ];

  const itensTemplatesContrato = [
    {
      nome: "CONTRATO DE LOCAÇÃO",
      rota: "/templates",
    },
    {
      nome: "OUTROS CONTRATOS",
      rota: "/templates-contrato/outros-contratos",
    },
    {
      nome: "LOGO E RODAPÉ",
      rota: "/cadastro-template-ct",
    },
  ];

  const itensAlteracoesContratuais = [
    {
      nome: "EMPRESAS",
      rota: "/alteracoes-contratuais/empresas",
    },
    {
      nome: "SÓCIOS",
      rota: "/alteracoes-contratuais/socios",
    },
    {
      nome: "ALTERAÇÕES CONTRATUAIS",
      rota: "/alteracoes-contratuais/processos",
    },
    {
      nome: "ETAPAS DO FLUXO",
      rota: "/alteracoes-contratuais/etapas",
    },
  ];

  const itensAdministracao = [
    {
      nome: "USUÁRIOS",
      rota: "/usuarios",
    },
    {
      nome: "PERFIL DE ACESSO",
      rota: "/administracao/perfil-acesso",
    },
    {
      nome: "ALÇADAS DE APROVAÇÃO",
      rota: "/alcadas-aprovacao",
    },
    {
      nome: "ALÇADA DE ASSINATURAS",
      rota: "/alcadas-assinaturas",
    },
    {
      nome: "AUDITORIA",
      rota: "/auditoria",
    },
    {
      nome: "LOGS DE ATIVIDADES",
      rota: "/logs-atividades",
    },
  ];

  const telasMenu = [
    { nome: "HOME", rota: "/home" },
    { nome: "MATRÍCULA DE IMÓVEIS", rota: "/matriculas-imoveis" },
    { nome: "CAR", rota: "/car" },
    { nome: "CCIR", rota: "/ccir" },
    { nome: "CCIR ANUAL", rota: "/ccir-anual" },
    { nome: "DITR", rota: "/ditr" },
    { nome: "DITR ANUAL", rota: "/ditr-anual" },
    { nome: "IPTU", rota: "/iptu" },
    { nome: "IPTU ANUAL", rota: "/iptu-anual" },
    { nome: "LOCATÁRIOS", rota: "/locatarios" },
    { nome: "UNIDADES LOCÁVEIS", rota: "/unidades-locaveis" },
    {
      nome: "UNIDADES LOCÁVEIS - LANÇAMENTO MENSAL",
      rota: "/unidades-locaveis/lancamento-mensal",
    },
    { nome: "RELÓGIO ÁGUA", rota: "/relogio-agua" },
    { nome: "RELÓGIO ENERGIA", rota: "/relogio-energia" },
    { nome: "CIDADES", rota: "/cidades" },
    { nome: "CARTÓRIOS", rota: "/cartorios" },
    { nome: "STATUS", rota: "/status" },
    { nome: "ENQUADRAMENTO", rota: "/enquadramentos" },
    { nome: "COMPLEMENTOS", rota: "/complemento" },
    { nome: "PROPRIETÁRIO", rota: "/proprietarios" },
    { nome: "GRUPO PROPRIETÁRIO", rota: "/grupo-proprietario" },
    { nome: "REPRESENTANTE LEGAL", rota: "/responsavel-legal" },
    { nome: "ÍNDICES DE REAJUSTE", rota: "/indices-reajuste" },
    ...itensAreasConstruidas.map((item) => ({
      nome: `ÁREAS CONSTRUÍDAS - CADASTRO - ${item.nome}`,
      rota: `/areas-construidas/cadastro-tipos-areas/${item.slug}`,
    })),

    ...itensAreasConstruidas.map((item) => ({
      nome: `ÁREAS CONSTRUÍDAS - LANÇAMENTOS - ${item.nome}`,
      rota: `/areas-construidas/lancamentos/${item.slug}`,
    })),
    ...itensWorkflowContratoLocacao,
    ...itensWorkflowOutrosInterno,
    ...itensWorkflowOutrosExterno,
    ...itensTemplatesContrato,
    ...itensAlteracoesContratuais,
    ...itensAdministracao,

    { nome: "ASSINATURA FINAL", rota: "/assinatura-final" },
  ];

  const telasFiltradas = buscaMenu.trim()
    ? telasMenu.filter((tela) =>
        tela.nome
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .includes(
            buscaMenu
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase(),
          ),
      )
    : [];

  const abrirTela = (rota) => {
    navigate(rota);
    setBuscaMenu("");
  };

  return (
    <aside className="w-64 min-h-screen mt-16 bg-[#1c1f26] text-white flex flex-col shadow-md font-sans">
      <div className="flex items-center justify-center py-4 border-b border-gray-700 bg-[#1c1f26] px-4">
        <span className="text-sm font-semibold tracking-wide uppercase text-gray-300 text-center">Matrícula de Imóveis</span>
      </div>

      <nav className="flex-1 overflow-visible px-4 py-6 space-y-1">
        <div className="relative mb-4">
          <div
            className="
      flex
      items-center
      w-full
      h-10
      px-3
      border
      border-gray-600
      rounded-md
      bg-[#161920]
      focus-within:border-[#1aa3b8]
    "
          >
            <i className="fas fa-search text-gray-400 text-sm mr-2" aria-hidden="true" />

            <input
              type="text"
              value={buscaMenu}
              onChange={(e) => setBuscaMenu(e.target.value)}
              placeholder="Pesquisar tela..."
              className="
        flex-1
        min-w-0
        bg-transparent
        border-none
        outline-none
        text-sm
        text-white
        placeholder-gray-500
      "
            />

            {buscaMenu && (
              <button
                type="button"
                onClick={() => setBuscaMenu("")}
                className="
          ml-2
          bg-transparent
          border-none
          text-gray-400
          hover:text-white
          cursor-pointer
        "
                title="Limpar pesquisa"
              >
                ×
              </button>
            )}
          </div>

          {buscaMenu.trim() && (
            <div
              className="
        absolute
        left-0
        right-0
        top-full
        mt-1
        z-50
        bg-[#1c1f26]
        border
        border-gray-600
        rounded-md
        shadow-xl
        overflow-hidden
      "
            >
              {telasFiltradas.length > 0 ? (
                telasFiltradas.map((tela) => (
                  <button
                    key={tela.rota}
                    type="button"
                    onClick={() => abrirTela(tela.rota)}
                    className="
              block
              w-full
              px-3
              py-2
              text-left
              text-sm
              text-gray-200
              bg-transparent
              hover:bg-[#2a2d36]
              border-none
              cursor-pointer
            "
                  >
                    {tela.nome}
                  </button>
                ))
              ) : (
                <div className="px-3 py-3 text-sm text-gray-500">Nenhuma tela encontrada</div>
              )}
            </div>
          )}
        </div>

        <NavLink to="/home" className={({ isActive }) => `${baseItemClasses} ${isActive ? activeItemClasses : ""}`}>
          HOME
        </NavLink>

        <button
          type="button"
          onClick={() => setOpenCadastroBasico((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>CADASTRO BÁSICO IMÓVEIS</span>

          <span className="text-gray-400">{openCadastroBasico ? "▾" : "▸"}</span>
        </button>

        {openCadastroBasico && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            <NavLink to="/matriculas-imoveis" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              MATRÍCULA DE IMÓVEIS
            </NavLink>

            <NavLink to="/complemento" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              COMPLEMENTOS
            </NavLink>

            <NavLink to="/car" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              CAR
            </NavLink>

            {/* IPTU */}
            <button
              type="button"
              onClick={() => setOpenIPTU((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>IPTU</span>

              <span className="text-gray-400">{openIPTU ? "▾" : "▸"}</span>
            </button>

            {openIPTU && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/iptu" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  CADASTRO
                </NavLink>

                <NavLink to="/iptu-anual" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  LANÇAMENTO ANUAL
                </NavLink>
              </div>
            )}

            {/* CCIR */}
            <button
              type="button"
              onClick={() => setOpenCCIR((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>CCIR</span>

              <span className="text-gray-400">{openCCIR ? "▾" : "▸"}</span>
            </button>

            {openCCIR && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/ccir" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  CADASTRO
                </NavLink>

                <NavLink to="/ccir-anual" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  LANÇAMENTO ANUAL
                </NavLink>
              </div>
            )}

            {/* DITR */}
            <button
              type="button"
              onClick={() => setOpenDITR((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>DITR</span>

              <span className="text-gray-400">{openDITR ? "▾" : "▸"}</span>
            </button>

            {openDITR && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/ditr" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  CADASTRO
                </NavLink>

                <NavLink to="/ditr-anual" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  LANÇAMENTO ANUAL
                </NavLink>
              </div>
            )}

            {/* RELÓGIO ENERGIA */}
            <button
              type="button"
              onClick={() => setOpenRelogioEnergia((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>RELÓGIO ENERGIA</span>

              <span className="text-gray-400">{openRelogioEnergia ? "▾" : "▸"}</span>
            </button>

            {openRelogioEnergia && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/relogio-energia" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  CADASTRO
                </NavLink>
              </div>
            )}

            {/* RELÓGIO ÁGUA */}
            <button
              type="button"
              onClick={() => setOpenRelogioAgua((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>RELÓGIO ÁGUA</span>

              <span className="text-gray-400">{openRelogioAgua ? "▾" : "▸"}</span>
            </button>

            {openRelogioAgua && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/relogio-agua" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  CADASTRO
                </NavLink>
              </div>
            )}

            {/* PESSOAS */}
            <button
              type="button"
              onClick={() => setOpenPessoas((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>PESSOAS</span>

              <span className="text-gray-400">{openPessoas ? "▾" : "▸"}</span>
            </button>

            {openPessoas && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                <NavLink to="/proprietarios" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  PROPRIETÁRIO
                </NavLink>

                <NavLink to="/grupo-proprietario" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  GRUPO PROPRIETÁRIO
                </NavLink>

                <NavLink to="/responsavel-legal" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  REPRESENTANTE LEGAL
                </NavLink>

                <NavLink to="/locatarios" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                  LOCATÁRIOS
                </NavLink>
              </div>
            )}
          </div>
        )}
        <button
          type="button"
          onClick={() => setOpenCadastrosAuxiliares((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>CADASTROS AUXILIARES</span>

          <span className="text-gray-400">{openCadastrosAuxiliares ? "▾" : "▸"}</span>
        </button>

        {openCadastrosAuxiliares && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            <NavLink to="/cidades" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              CIDADES
            </NavLink>

            <NavLink to="/cartorios" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              CARTÓRIOS
            </NavLink>

            <NavLink to="/status" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              STATUS
            </NavLink>

            <NavLink to="/enquadramentos" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              ENQUADRAMENTO
            </NavLink>

            <NavLink to="/indices-reajuste" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              ÍNDICES DE REAJUSTE
            </NavLink>
          </div>
        )}

        <button
          type="button"
          onClick={() => setOpenAreasConstruidas((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>ÁREAS CONSTRUÍDAS</span>

          <span className="text-gray-400">{openAreasConstruidas ? "▾" : "▸"}</span>
        </button>

        {openAreasConstruidas && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {/* CADASTRO TIPOS ÁREAS */}
            <button
              type="button"
              onClick={() => setOpenCadastroTiposAreas((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>CADASTRO TIPOS ÁREAS</span>

              <span className="text-gray-400">{openCadastroTiposAreas ? "▾" : "▸"}</span>
            </button>

            {openCadastroTiposAreas && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                {itensAreasConstruidas.map((item) => (
                  <NavLink
                    key={`cadastro-${item.slug}`}
                    to={`/areas-construidas/cadastro-tipos-areas/${item.slug}`}
                    className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}
                  >
                    {item.nome}
                  </NavLink>
                ))}
              </div>
            )}

            {/* LANÇAMENTOS */}
            <button
              type="button"
              onClick={() => setOpenLancamentosAreas((v) => !v)}
              className={`${subItemClasses} w-full flex items-center justify-between text-left bg-transparent`}
            >
              <span>LANÇAMENTOS</span>

              <span className="text-gray-400">{openLancamentosAreas ? "▾" : "▸"}</span>
            </button>

            {openLancamentosAreas && (
              <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
                {itensAreasConstruidas.map((item) => (
                  <NavLink
                    key={`lancamento-${item.slug}`}
                    to={`/areas-construidas/lancamentos/${item.slug}`}
                    className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}
                  >
                    {item.nome}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        )}

        {/* UNIDADES LOCÁVEIS */}
        <button
          type="button"
          onClick={() => setOpenUnidadesLocaveis((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>UNIDADES LOCÁVEIS</span>

          <span className="text-gray-400">{openUnidadesLocaveis ? "▾" : "▸"}</span>
        </button>

        {openUnidadesLocaveis && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            <NavLink to="/unidades-locaveis" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              CADASTRO
            </NavLink>

            <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
              <NavLink to="/unidades-locaveis/lancamento-mensal" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                LANÇAMENTO MENSAL
              </NavLink>
            </div>
          </div>
        )}

        {/* WORKFLOW CONTRATO LOCAÇÃO */}
        <button
          type="button"
          onClick={() => setOpenWorkflowContratoLocacao((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>WORKFLOW CONTRATO LOCAÇÃO</span>

          <span className="text-gray-400">{openWorkflowContratoLocacao ? "▾" : "▸"}</span>
        </button>

        {openWorkflowContratoLocacao && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensWorkflowContratoLocacao.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}

        {/* WORKFLOW OUTROS CONTRATOS INTERNO */}
        <button
          type="button"
          onClick={() => setOpenWorkflowOutrosInterno((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>WORKFLOW OUTROS CONTRATOS INTERNO</span>

          <span className="text-gray-400">{openWorkflowOutrosInterno ? "▾" : "▸"}</span>
        </button>

        {openWorkflowOutrosInterno && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensWorkflowOutrosInterno.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}

        {/* WORKFLOW OUTROS CONTRATOS EXTERNO */}
        <button
          type="button"
          onClick={() => setOpenWorkflowOutrosExterno((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>WORKFLOW OUTROS CONTRATOS EXTERNO</span>

          <span className="text-gray-400">{openWorkflowOutrosExterno ? "▾" : "▸"}</span>
        </button>

        {openWorkflowOutrosExterno && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensWorkflowOutrosExterno.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}

        {/* TEMPLATES DE CONTRATO */}
        <button
          type="button"
          onClick={() => setOpenTemplatesContrato((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>TEMPLATES DE CONTRATO</span>

          <span className="text-gray-400">{openTemplatesContrato ? "▾" : "▸"}</span>
        </button>

        {openTemplatesContrato && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensTemplatesContrato.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}
        {/* ALTERAÇÕES CONTRATUAIS */}
        <button
          type="button"
          onClick={() => setOpenAlteracoesContratuais((v) => !v)}
          className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}
        >
          <span>ALTERAÇÕES CONTRATUAIS</span>

          <span className="text-gray-400">{openAlteracoesContratuais ? "▾" : "▸"}</span>
        </button>

        {openAlteracoesContratuais && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensAlteracoesContratuais.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}
        {/* ADMINISTRAÇÃO */}
        <button type="button" onClick={() => setOpenAdministracao((v) => !v)} className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}>
          <span>ADMINISTRAÇÃO</span>

          <span className="text-gray-400">{openAdministracao ? "▾" : "▸"}</span>
        </button>

        {openAdministracao && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            {itensAdministracao.map((item) => (
              <NavLink key={item.rota} to={item.rota} className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
                {item.nome}
              </NavLink>
            ))}
          </div>
        )}
        <button type="button" onClick={() => setOpenSistema((v) => !v)} className={`${groupBtnClasses} flex items-center justify-between bg-transparent`}>
          <span>SISTEMA</span>
          <span className="text-gray-400">{openSistema ? "▾" : "▸"}</span>
        </button>

        {openSistema && (
          <div className="ml-3 border-l border-gray-700 pl-2 space-y-1">
            <NavLink to="/assinatura-final" className={({ isActive }) => `${subItemClasses} ${isActive ? activeItemClasses : ""}`}>
              ASSINATURA FINAL
            </NavLink>
          </div>
        )}
      </nav>
    </aside>
  );
}

export default Sidebar;
